import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { SessionService } from "@services/session.service";

@Component({
  selector: "app-session-timer",
  templateUrl: "./session-timer.component.html",
  styleUrls: ["./session-timer.component.scss"]
})
export class SessionTimerComponent implements OnInit, OnDestroy {
  tiempoRestante: string = "--:--";
  esUrgente: boolean = false;

  /** Umbral (ms) bajo el cual el timer se marca como "urgente". */
  private readonly umbralUrgenteMs = 5 * 60 * 1000;

  /** Timestamp (ms) en que expira la sesión actual. */
  private expiracionMs: number | null = null;

  private intervalId: ReturnType<typeof setInterval> | null = null;
  private sesionSub: Subscription | null = null;

  constructor(private sessionService: SessionService) {}

  ngOnInit(): void {
    // Fuente única de verdad: el BehaviorSubject de SessionService.
    // Cada vez que cambia la sesión, recalculamos la expiración y reiniciamos el intervalo.
    this.sesionSub = this.sessionService.sesion$.subscribe((sesion) => {
      if (sesion?.expiracion) {
        this.expiracionMs = new Date(sesion.expiracion).getTime();
        this.actualizarTiempo();
        this.iniciarIntervalo();
      } else {
        this.expiracionMs = null;
        this.tiempoRestante = "--:--";
        this.esUrgente = false;
        this.detenerIntervalo();
      }
    });
  }

  ngOnDestroy(): void {
    this.detenerIntervalo();
    this.sesionSub?.unsubscribe();
  }

  private iniciarIntervalo(): void {
    this.detenerIntervalo();
    this.intervalId = setInterval(() => this.actualizarTiempo(), 1000);
  }

  private actualizarTiempo(): void {
    if (this.expiracionMs === null) return;

    const msRestantes = this.expiracionMs - Date.now();

    if (msRestantes <= 0) {
      this.tiempoRestante = "00:00";
      this.esUrgente = true;
      this.detenerIntervalo();
      return;
    }

    const totalSegundos = Math.floor(msRestantes / 1000);
    const horas = Math.floor(totalSegundos / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const segundos = totalSegundos % 60;

    this.esUrgente = msRestantes < this.umbralUrgenteMs;

    this.tiempoRestante = horas > 0
      ? `${this.pad(horas)}:${this.pad(minutos)}:${this.pad(segundos)}`
      : `${this.pad(minutos)}:${this.pad(segundos)}`;
  }

  private pad(n: number): string {
    return n.toString().padStart(2, "0");
  }

  private detenerIntervalo(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
